import script from "./Page_3.vue?vue&type=script&setup=true&lang=js"
export * from "./Page_3.vue?vue&type=script&setup=true&lang=js"

import "./Page_3.vue?vue&type=style&index=0&id=58ef56a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ef56a2"]])

export default __exports__